// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Video_wrap__3NXFw","overlay":"Video_overlay__1S6zn","iconPlay":"Video_iconPlay__3-TRv"};